import React, { useState } from 'react';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBTextArea,
  MDBBtn
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <MDBContainer className="my-5 py-5">
      <MDBRow className="justify-content-center">
        <MDBCol lg="8">
          <MDBCard>
            <MDBCardBody className="p-5">
              <h2 className="text-center mb-5">{t('contact.title')}</h2>
              <form onSubmit={handleSubmit}>
                <MDBRow className="mb-4">
                  <MDBCol>
                    <MDBInput
                      label={t('contact.name')}
                      name='name'
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </MDBCol>
                  <MDBCol>
                    <MDBInput
                      type='email'
                      label={t('contact.email')}
                      name='email'
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </MDBCol>
                </MDBRow>

                <MDBInput
                  label={t('contact.subject')}
                  className="mb-4"
                  name='subject'
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />

                <MDBTextArea
                  label={t('contact.message')}
                  rows={4}
                  className="mb-4"
                  name='message'
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <div className="text-center">
                  <MDBBtn type='submit' className="w-50">
                    {t('contact.send')}
                  </MDBBtn>
                </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      <MDBRow className="mt-5">
        <MDBCol md="4" className="text-center mb-4">
          <i className="fas fa-map-marker-alt fa-2x mb-3 text-primary"></i>
          <h5>{t('contact.address')}</h5>
          <p>{t('footer.contact.address')}</p>
        </MDBCol>
        <MDBCol md="4" className="text-center mb-4">
          <i className="fas fa-phone fa-2x mb-3 text-primary"></i>
          <h5>{t('contact.phone')}</h5>
          <p>{t('footer.contact.phone')}</p>
        </MDBCol>
        <MDBCol md="4" className="text-center mb-4">
          <i className="fas fa-envelope fa-2x mb-3 text-primary"></i>
          <h5>{t('contact.email.label')}</h5>
          <p>{t('footer.contact.email')}</p>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default Contact; 